import { memo, useCallback } from 'react';
import PropTypes from 'prop-types';
import { SelectableChip } from '@aimsos/ui';

/**
 * One category pill in `WidgetTypePicker` (CT-5196).
 *
 * `memo()` + its own `useCallback`, mirroring `WidgetTypeTile` one component
 * below it in the same file — extracted so the pill list stops using an
 * inline `onClick` inside `.map()` (CT-5183 review).
 */
const CategoryPill = memo(function CategoryPill({ id, label, selected, onSelect }) {
  const handleClick = useCallback(() => onSelect(id), [onSelect, id]);

  return (
    <SelectableChip size="m" selected={selected} onClick={handleClick}>
      {label}
    </SelectableChip>
  );
});

CategoryPill.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  selected: PropTypes.bool,
  onSelect: PropTypes.func.isRequired,
};

export default CategoryPill;
